import { Box, CircularProgress, Typography } from '@mui/material';
import { Construction } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import styles from './serviceUnavailable.module.css';

export const ServiceUnavailable = () => {
  const { t } = useTranslation();

  return (
    <Box className={styles.container}>
      <Box className={styles.card}>
        <Construction className={styles.icon} />
        <Typography variant="h5" className={styles.title}>
          {t("We're updating the app")}
        </Typography>
        <Typography variant="body1" className={styles.subtitle}>
          {t("The service will be back shortly. This page will refresh automatically as soon as it's ready.")}
        </Typography>
        <Box className={styles.checkingRow}>
          <CircularProgress size={16} thickness={5} />
          <Typography variant="body2" className={styles.checkingText}>
            {t('Checking connection…')}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
